import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { UserCircle } from 'lucide-react';

import logo from '../../assets/images/Logo.png';
 
 
import './topnavBar.css';
 
const TopNavbar = () => {

  const [userEmail, setUserEmail] = useState('');

  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useNavigate();
 
  useEffect(() => {

    const email = localStorage.getItem('user_name');

    if (email) setUserEmail(email);

  }, []);
 
  const handleLogout = () => {

    localStorage.clear();

    navigate('/');

  };
 
  return (
<header className="admin-dashboard-header">
<div className="top-logo-wrapper">
<div className="top-logo-container">
<img src={logo} alt="Company Logo" className="logo-image" />
</div>
</div>
<div className="admin-top-right-icons">
<span className="admin-candidate-name">{userEmail}</span>
<UserCircle className="admin-icon" onClick={() => setShowDropdown(!showDropdown)} />

        {showDropdown && (
<div className="admin-dropdown-menu">
<ul>
<li>Change Password</li>
<li onClick={handleLogout}>Logout</li>
</ul>
</div>

        )}
</div>
</header>

  );

};
 
export default TopNavbar;

 